export default __webpack_public_path__ + "static/media/blurb_cloud_back.5eb85e77.svg";